// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pages-Login-styles___pageLogin--SzvSY {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

  .pages-Login-styles___pageLogin--SzvSY .pages-Login-styles___card--z2GfF {
    width: 100%;
    max-width: 496px;
    padding: 24px 88px 32px;
  }

  .pages-Login-styles___pageLogin--SzvSY .pages-Login-styles___card--z2GfF .pages-Login-styles___cardContent--dAwaO {
      padding: 0;
    }

  .pages-Login-styles___pageLogin--SzvSY .pages-Login-styles___card--z2GfF .pages-Login-styles___title--XttGa {
      font-size: 36px;
      font-weight: 700;
    }

  .pages-Login-styles___pageLogin--SzvSY .pages-Login-styles___card--z2GfF .pages-Login-styles___button--bbqFQ {
      margin: 16px 0 0;
    }

  .pages-Login-styles___pageLogin--SzvSY .pages-Login-styles___card--z2GfF .pages-Login-styles___dHaveAccount--rETgK {
      margin-top: 20px;
      font-size: 14px;
    }

  .pages-Login-styles___pageLogin--SzvSY .pages-Login-styles___card--z2GfF .pages-Login-styles___dHaveAccount--rETgK .pages-Login-styles___signUp--AsZIV {
        font-weight: bold;
        text-decoration: underline;
      }

  .pages-Login-styles___pageLogin--SzvSY .pages-Login-styles___card--z2GfF .pages-Login-styles___loginError--z6L2s {
      color: red;
      text-align: center;
      font-size: 12px;
      padding: 10px 0;
    }

  .pages-Login-styles___pageLogin--SzvSY .pages-Login-styles___textField--ZqSEU button {
      padding: 0 !important;
    }

  .pages-Login-styles___pageLogin--SzvSY .pages-Login-styles___icon--wh96h {
    width: 19px;
    height: 19px;
  }

  .pages-Login-styles___pageLogin--SzvSY .pages-Login-styles___eyeVisible--Q9jsJ {
    fill: #318afb;
  }

  .pages-Login-styles___pageLogin--SzvSY .pages-Login-styles___link--pkJ6S {
    cursor: pointer;
    display: block;
    color: #318afb;
    margin: 12px 0 0;
  }
`, "",{"version":3,"sources":["webpack://./pages/Login/styles.pcss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AA0Df;;EAxDE;IACE,WAAW;IACX,gBAAgB;IAChB,uBAAuB;EA8BzB;;EA5BE;MACE,UAAU;IACZ;;EAEA;MACE,eAAe;MACf,gBAAgB;IAClB;;EAEA;MACE,gBAAgB;IAClB;;EAEA;MACE,gBAAgB;MAChB,eAAe;IAKjB;;EAJE;QACE,iBAAiB;QACjB,0BAA0B;MAC5B;;EAGF;MACE,UAAU;MACV,kBAAkB;MAClB,eAAe;MACf,eAAe;IACjB;;EAIA;MACE,qBAAqB;IACvB;;EAGF;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,cAAc;IACd,cAAc;IACd,gBAAgB;EAClB","sourcesContent":[".pageLogin {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n\n  .card {\n    width: 100%;\n    max-width: 496px;\n    padding: 24px 88px 32px;\n\n    .cardContent {\n      padding: 0;\n    }\n\n    .title {\n      font-size: 36px;\n      font-weight: 700;\n    }\n\n    .button {\n      margin: 16px 0 0;\n    }\n\n    .dHaveAccount {\n      margin-top: 20px;\n      font-size: 14px;\n      .signUp {\n        font-weight: bold;\n        text-decoration: underline;\n      }\n    }\n\n    .loginError {\n      color: red;\n      text-align: center;\n      font-size: 12px;\n      padding: 10px 0;\n    }\n  }\n\n  .textField {\n    button {\n      padding: 0 !important;\n    }\n  }\n\n  .icon {\n    width: 19px;\n    height: 19px;\n  }\n\n  .eyeVisible {\n    fill: #318afb;\n  }\n\n  .link {\n    cursor: pointer;\n    display: block;\n    color: #318afb;\n    margin: 12px 0 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageLogin": `pages-Login-styles___pageLogin--SzvSY`,
	"card": `pages-Login-styles___card--z2GfF`,
	"cardContent": `pages-Login-styles___cardContent--dAwaO`,
	"title": `pages-Login-styles___title--XttGa`,
	"button": `pages-Login-styles___button--bbqFQ`,
	"dHaveAccount": `pages-Login-styles___dHaveAccount--rETgK`,
	"signUp": `pages-Login-styles___signUp--AsZIV`,
	"loginError": `pages-Login-styles___loginError--z6L2s`,
	"textField": `pages-Login-styles___textField--ZqSEU`,
	"icon": `pages-Login-styles___icon--wh96h`,
	"eyeVisible": `pages-Login-styles___eyeVisible--Q9jsJ`,
	"link": `pages-Login-styles___link--pkJ6S`
};
module.exports = ___CSS_LOADER_EXPORT___;
